<template>
  <div class="restaurant-modifiers">
    <div class="row my-3">
      <h2 class="">{{ $t('modifiers.title') }}
        <span v-show="this.MODIFIERS_LOADING.remove" class="spinner-border spinner-border-sm text-success" role="status">
          <span class="visually-hidden">Loading...</span>
        </span>
      </h2>
    </div>
    <div class="row">
      <div class="col-12 mb-4 d-flex justify-content-between">
        <div>
          <a @click="openModalForAdd" class="btn btn-sm btn-outline-success px-3 me-2">{{ $t('modifiers.create') }}</a>
          <router-link :to="{name: 'ModifiersOption'}" class="btn btn-sm btn-warning px-3">{{ $t('modifiers.options') }}</router-link>
        </div>
        <div class="col-12 col-md-2 mb-4 d-flex align-items-center">
          <svg width="1rem" height="1rem" fill="gray" class="mb-1 me-2">
            <use xlink:href="../../assets/ico/bootstrap-icons.svg#archive"/>
          </svg>
          <select v-model="sortByCategory"  class="form-select form-select-sm" aria-label="Sort restaurant's menu">
            <option value="default">{{ $t('modifiers.allCategories') }}</option>
            <option v-for="name in this.MODIFIERS_CAT"
                    :value="name">{{ name }}
            </option>
          </select>
        </div>
      </div>
      <div v-for="(mf, index) in this.sortModifiers" :key="index" class="col-12 col-md-6 col-lg-6 col-xl-4">
        <div class="card mb-4">
          <div class="card-header">{{ mf.administrative_name }}</div>
          <div class="card-body">
            <div class="modifier-top d-flex justify-content-between">
              <div>
                {{ mf.title }}
                <svg width="1rem" height="1rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.titleForWebsite')">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#info-circle"/>
                </svg>
              </div>
              <div>
                <svg width="1rem" height="1rem" fill="gray" class="mb-1">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#archive"/>
                </svg>
                {{ mf.category }}
              </div>
            </div>
            <div class="modifier-description text-muted mt-2">{{ mf.description }}</div>
            <div class="modifier-info d-flex justify-content-between mt-2">
              <div class="d-flex align-items-center ">
                <div class="me-2">
                  <svg  v-show="mf.type === 'modify' " width="1.4rem" height="1.4rem" fill="LimeGreen" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.forAddOption')">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#folder-plus"/>
                  </svg>
                  <svg v-show="mf.type === 'remove' " width="1.4rem" height="1.4rem" fill="FireBrick" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.forDeleteOption')">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#folder-minus"/>
                  </svg>
                </div>
                <div class="me-2">
                  <svg v-if="mf.required" width="1.4rem" height="1.4rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.required')">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#braces-asterisk"/>
                  </svg>
                  <svg v-else width="1.4rem" height="1.4rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.notRequired')">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#braces"/>
                  </svg>
                </div>
                <div class="me-2">
                  <svg v-if="mf.multiple_choice" width="1.4rem" height="1.4rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.multipleChoice')">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#calendar3"/>
                  </svg>
                  <svg v-else width="1.4rem" height="1.4rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.onlyOneOption')">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#calendar3-event"/>
                  </svg>
                </div>
                <div v-show="false" class="me-2 border rounded-1 px-1" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.minQty')">
                  <svg width="1rem" height="1rem" fill="gray" class="">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#caret-down"/>
                  </svg> {{mf.choose_min}}
                </div>
                <div class="border rounded-1 px-1" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.maxQty')">
                  <svg width="1rem" height="1rem" fill="gray" class="pb-1">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#caret-up"/>
                  </svg> {{mf.choose_max}}
                </div>
              </div>
              <div>
                <button
                    @click.stop
                    @click="openModalForRemove(mf)"
                    class="btn btn-outline-danger pt-0 px-2  me-2">
                  <svg width="1.2rem" height="1.2rem" fill="currentColor">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#trash3-fill"/>
                  </svg>
                </button>
                <button
                    @click="openModalAddOptionToModifier(mf)"
                    class="btn btn-sm btn-outline-warning me-2">
                  <svg class="bi" width="1.3rem" height="1.3rem" fill="currentColor">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#patch-plus-fill"/>
                  </svg>
                </button>
                <button
                    @click="openModalForChange(mf)"
                    class="btn btn-sm btn-outline-success pt-1">
                  <svg class="bi fs-4 mb-1 delete-product-ico" width="1rem" height="1rem" fill="currentColor">
                    <use xlink:href="../../assets/ico/bootstrap-icons.svg#pencil-fill"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="modifier-options d-flex align-self-stretch flex-wrap mt-3">
              <div class="modifier-options__item" v-for="option in this.optionsInModifier(mf.option_ids)">
                <div class="d-flex flex-wrap align-items-center border rounded-1 p-1 mb-1">
                  <img class="modifier-options__item-img rounded-1" :src="option.src" :alt="option.title">
                  <span class="small">{{option.administrative_name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal add modifier -->
    <div class="modal fade" id="addModifier" tabindex="-1" aria-labelledby="addModifiersLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="addModifiersLabel">{{this.modalTitle}}
                <span v-show="this.MODIFIERS_LOADING.add" class="spinner-border spinner-border-sm text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
            </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body row">
            <div class="col-12 col-md-6 mb-3">
              <label for="modifierTitleAdmin" class="form-label">{{ $t('modifiers.titleForAdminPanel') }}</label>
              <input v-model.trim="newMf.administrative_name" type="text" class="form-control" id="modifierTitleAdmin">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="modifierTitle" class="form-label">{{ $t('modifiers.titleForWebsite') }}</label>
              <input v-model.trim="newMf.title" type="text" class="form-control" id="modifierTitle">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="modifierCategory" class="form-label">{{ $t('modifiers.category') }}</label>
              <input v-model.trim="newMf.category" type="form-control" class="form-control" id="modifierCategory" list="modifiersCategoryList">
              <datalist id="modifiersCategoryList">
                <option v-for="cat in this.MODIFIERS_CAT" :value="cat">{{ cat }}</option>
              </datalist>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <label for="modifierDescription" class="form-label">{{ $t('modifiers.description') }}</label>
              <input v-model.trim="newMf.description" type="text" class="form-control" id="modifierDescription">
            </div>
            <div class="col-12 col-md-6 mb-3">
              <p class="mb-2">{{ $t('modifiers.type') }}
                <svg width="1rem" height="1rem" fill="gray" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('modifiers.addOrDeleteOptionsFromTheProduct')">
                  <use xlink:href="../../assets/ico/bootstrap-icons.svg#info-circle"/>
                </svg>
              </p>
              <div class="form-check form-check-inline">
                <input v-model="newMf.type" class="form-check-input" type="radio" name="modifierType" id="modifierTypeAdd" value="modify" checked>
                <label class="form-check-label select-none" for="modifierTypeAdd">{{ $t('modifiers.add') }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input v-model.trim="newMf.type" class="form-check-input" type="radio" name="modifierType" id="modifierTypeRemove" value="remove">
                <label class="form-check-label select-none" for="modifierTypeRemove">{{ $t('modifiers.remove') }}</label>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
              <p class="mb-2">{{ $t('modifiers.properties') }}</p>
              <div class="form-check form-switch form-check-inline">
                <input v-model.trim="newMf.required" class="form-check-input select-none" type="checkbox" role="switch" id="modifierRequired">
                <label class="form-check-label select-none" for="modifierRequired">{{ $t('modifiers.required') }}</label>
              </div><div class="form-check form-switch form-check-inline">
                <input v-model.trim="newMf.multiple_choice" class="form-check-input select-none" type="checkbox" role="switch" id="modifierMultipleChoice">
                <label class="form-check-label select-none" for="modifierMultipleChoice">{{ $t('modifiers.multichoice') }}</label>
              </div>
            </div>
            <div class="col-6 col-lg-3 mb-3">
              <label for="modifierMin" class="form-label">{{ $t('modifiers.qtyMin') }}</label>
              <input v-model.number.trim="newMf.choose_min" type="number" class="form-control" id="modifierMin" disabled>
            </div>
            <div class="col-6 col-lg-3 mb-3">
              <label for="modifierMax" class="form-label">{{ $t('modifiers.qtyMax') }}</label>
              <input v-model.number.trim="newMf.choose_max"
                     :disabled="!newMf.multiple_choice"
                     type="number" class="form-control" id="modifierMax">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('modifiers.close') }}</button>
            <button
                v-show="this.modalType === 'add'"
                @click="addModifier"
                :disabled="this.disableSendBtn"
                type="button" class="btn btn-success">{{ $t('modifiers.save') }}
            </button>
            <button
                v-show="this.modalType === 'change'"
                @click="changeModifier"
                type="button" class="btn btn-success">{{ $t('modifiers.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal add option to modifier-->
    <div class="modal fade" id="modalOptionToModifier" tabindex="-1" aria-labelledby="modalOptionToModifierLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalOptionToModifierLabel">{{ $t('modifiers.updateModifierOptions') }}
              <span v-show="this.MODIFIERS_LOADING.option" class="spinner-border spinner-border-sm text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
            </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div v-for="(option, index) in this.OPTIONS"
                   :key="index"
                   class="col-4 col-md-3 col-lg-2 options-in-modifiers">
                <input type="checkbox" :id="index" :value="index" class="options__item" v-model="selectedOptionsInModifier">
                <label :for="index" class="w-100">
                  <div class="card position-relative mb-4">
                    <div class="select-icon position-absolute top-0 end-0 pt-1 pe-2">
                        <svg width="1.4rem" height="1.4rem" fill="orange">
                          <use xlink:href="../../assets/ico/bootstrap-icons.svg#check-circle-fill"/>
                        </svg>
                    </div>
                    <div style="height: 100px;" class="text-center mt-2">
                      <img v-if="option.src" :src="option.src" class="img-fluid h-100" :alt="option.title">
                      <img v-else src="../../assets/img/placeholder-option.png" class="img-fluid h-100"
                           :alt="option.title">
                    </div>
                    <div class="card-body p-2">
                      <p class="mb-1">{{ option.administrative_name }}</p>
                      <div class="border-1 border-top d-flex justify-content-between">
                        <span class="small">{{ option.price }} {{ $t('modifiers.currency') }}</span>
                        <span class="small">{{ option.weight }} {{ $t('modifiers.weight') }}</span>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('modifiers.close') }}</button>
            <button
                @click="clearOptionInModifier"
                type="button" class="btn btn-outline-info">{{ $t('modifiers.clear') }}
            </button>
            <button
                @click="addOptionInModifier"
                type="button" class="btn btn-success">{{ $t('modifiers.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
<!--    modal remove modifier-->
    <div class="modal fade" id="modalRemoveModifier" tabindex="-1" aria-labelledby="modalRemoveModifierLabel" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalRemoveModifierLabel">{{ $t('modifiers.deleteModifier') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <p>{{ $t('modifiers.delete') }}<b>{{modifierNow.administrative_name}}</b> ?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('modifiers.no') }}</button>
            <button
                @click="removeModifier"
                data-bs-dismiss="modal"
                type="button" class="btn btn-danger">{{ $t('modifiers.yes') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import i18n from "@/i18n";
import {Tooltip, Modal} from "bootstrap";

export default {
  name: "Modifiers",
  data() {
    return {
      modalType: 'add', //modal window for add modifier or change
      sortByCategory: 'default',
      newMf: {
        administrative_name: '',
        title: '',
        category: '',
        description: '',
        type: 'modify',
        required: true,
        multiple_choice: false,
        choose_min: 1,
        choose_max: 1,
        options: [],
      },
      modifierNow: '',
      selectedOptionsInModifier: []
    }
  },
  computed: {
    ...mapGetters([
        'MODIFIERS',
        'MODIFIERS_CAT',
        'MODIFIERS_LOADING',
        'MODIFIERS_SORT',
        'OPTIONS'
    ]),
    disableSendBtn() {
      if (
          this.newMf.administrative_name &&
          this.newMf.title &&
          this.newMf.category &&
          this.newMf.description
      ) {
        return false
      } else {
        return true
      }
    },
    modalTitle() {
      if (this.modalType === 'add') {return i18n.global.t('modifiers.addModifier')}
      if (this.modalType === 'change') {return i18n.global.t('modifiers.updateModifier')}
    },
    sortModifiers() {
      this.$store.commit('setModifiersSort', this.sortByCategory);
      let sort = this.sortByCategory
      if (sort !== 'default') {
        let filtered = Object.values(this.MODIFIERS).filter(function (elem) {
          if (elem.category === sort) {
            return true
          }
        })
        return filtered
      } else {
        return this.MODIFIERS
      }
    },
  },
  methods: {
    clearInputs() {
      this.newMf = {
        administrative_name: '',
        title: '',
        category: '',
        description: '',
        type: 'modify',
        required: true,
        multiple_choice: false,
        choose_min: 1,
        choose_max: 1,
        options: [],
      }
    },
    async addModifier() {
      let restId = this.$route.params.id
      let newMf = this.newMf
      let modifierIsAdding = await this.$store.dispatch('addModifier', {restId, newMf})
      if (modifierIsAdding) {
        this.closeModal('addModifier')
      }
      return true
    },
    async changeModifier() {
      let restId = this.$route.params.id
      let newMf = this.newMf
      let modifierIsChanging = await this.$store.dispatch('changeModifier', {restId, newMf})
      if (modifierIsChanging) {
        this.closeModal('addModifier')
      }
      return true
    },
    async removeModifier() {
      this.$store.dispatch('removeModifier', this.modifierNow)
    },
    openModalForAdd() {
      this.clearInputs();
      this.modalType = 'add';
      const modifierModal = new Modal(document.querySelector('#addModifier'));
      modifierModal.show();
    },
    closeModal(idModal) {
      const openModal = document.getElementById(idModal)
      let modal = Modal.getOrCreateInstance(openModal);
      modal.hide();
    },
    openModalForChange(mf) {
      this.newMf.administrative_name = mf.administrative_name
      this.newMf.title = mf.title
      this.newMf.category = mf.category
      this.newMf.description = mf.description
      this.newMf.type = mf.type
      this.newMf.required = mf.required
      this.newMf.multiple_choice = mf.multiple_choice
      this.newMf.choose_min = mf.choose_min
      this.newMf.choose_max = mf.choose_max
      this.newMf.options = mf.options
      this.newMf.id = mf.id
      this.modalType = 'change';
      this.modifierNow = mf; // записываем временно, чтобы обратиться для сравнения
      const modifierModal = new Modal(document.querySelector('#addModifier'));
      modifierModal.show();
    },
    openModalForRemove(mf) {
      this.modifierNow = mf;
      const modifierModal = new Modal(document.querySelector('#modalRemoveModifier'));
      modifierModal.show();
    },
    // TODO: options in the modifier
    openModalAddOptionToModifier(mf) {
      this.modifierNow = mf;
      this.selectedOptionsInModifier = mf.option_ids
      const optionModal = new Modal(document.querySelector('#modalOptionToModifier'));
      optionModal.show();
    },
    async addOptionInModifier() {
      let payload = {
        restId: this.modifierNow.restaurant_id,
        id: this.modifierNow.id,
        options: {
          option_ids: this.selectedOptionsInModifier
        }
      }
      let optionIsChanging = await this.$store.dispatch('changeOptionInModifier', payload)
      if (optionIsChanging) {
        this.closeModal('modalOptionToModifier')
      }
    },
    clearOptionInModifier() {
      this.selectedOptionsInModifier = [];
    },
    optionsInModifier(ids) {
      let options = []
      ids.forEach((item) => {
        if(this.OPTIONS[item]) {
          options.push(this.OPTIONS[item])
        }
      })
      return options;
    }
  },
  watch: {
    'newMf.choose_max'(newValue) {
      if (!this.newMf.multiple_choice) { this.newMf.choose_max = 1 }
      if (this.newMf.multiple_choice && newValue <= 1) { this.newMf.choose_max = 1 }
    },
    'newMf.multiple_choice'(newMultiple) {
      if (newMultiple) {
        this.modifierNow.choose_max ? this.newMf.choose_max = this.modifierNow.choose_max : this.newMf.choose_max = 1
      } else {
        this.newMf.choose_max = 1
      }
      // newMultiple ? this.newMf.choose_max = this.modifierNow.choose_max : this.newMf.choose_max = 1;
    }
  },
  created() {
    this.sortByCategory = this.MODIFIERS_SORT
  },
  mounted() {
    let restId = this.$route.params.id
    if(!Object.values(this.MODIFIERS).length) {
      this.$store.dispatch('getModifiers', restId)
    }
    if(!Object.values(this.OPTIONS).length) {
      this.$store.dispatch('getOptions', restId)
    }
    //initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  }
}
</script>

<style scoped>

</style>
